module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "id",
      "size": "small"
    },
    model: {
      value: (_vm.params.anchor_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "anchor_id", $$v)
      },
      expression: "params.anchor_id"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "主播名称",
      "size": "small"
    },
    model: {
      value: (_vm.params.nickname),
      callback: function($$v) {
        _vm.$set(_vm.params, "nickname", $$v)
      },
      expression: "params.nickname"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机",
      "size": "small"
    },
    model: {
      value: (_vm.params.mobile),
      callback: function($$v) {
        _vm.$set(_vm.params, "mobile", $$v)
      },
      expression: "params.mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "直播流名称",
      "size": "small"
    },
    model: {
      value: (_vm.params.stream_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "stream_name", $$v)
      },
      expression: "params.stream_name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 5
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择状态"
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, _vm._l((_vm.statusOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "size": "mini",
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 5
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请选择店铺",
      "remote": "",
      "remote-method": _vm.getDistributorList
    },
    on: {
      "change": _vm.handleDistibutorChange
    },
    model: {
      value: (_vm.params.distributor_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "distributor_name", $$v)
      },
      expression: "params.distributor_name"
    }
  }, _vm._l((_vm.distributorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.params.inca_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "inca_id", $$v)
      },
      expression: "params.inca_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "start-placeholder": "开始日期",
      "ange-separator": "至",
      "end-placeholder": "结束日期",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": _vm.addItems
    }
  }, [_vm._v("添加")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.ItemsList
      },
      on: {
        "selection-change": _vm.handleSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "align": "center",
        "label": "全选"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "width": "110",
        "fixed": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            }
          }, [_c('router-link', {
            staticClass: "btn-gap",
            attrs: {
              "to": {
                path: _vm.matchInternalRoute('livelist'),
                query: {
                  anchor_id: scope.row.anchor_id,
                  anchor_name: scope.row.nickname
                }
              }
            }
          }, [_vm._v("直播记录")])], 1), _vm._v(" "), _c('el-popover', {
            attrs: {
              "placement": "right",
              "width": "245",
              "trigger": "hover"
            }
          }, [_c('div', {
            staticClass: "operating-icons"
          }, [_c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.editItemsAction(scope.$index, scope.row, false)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.deleteItemsAction(scope.$index, scope.row)
              }
            }
          }, [_vm._v("删除")]), _vm._v(" "), (scope.row.status == 'online') ? _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.updateItemStatus(scope.row, 'offline')
              }
            }
          }, [_vm._v("下线")]) : _vm._e(), _vm._v(" "), (scope.row.status == 'offline') ? _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.updateItemStatus(scope.row, 'online')
              }
            }
          }, [_vm._v("上线")]) : _vm._e(), _vm._v(" "), (false) ? _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.handleGetPushUrl(scope.row)
              }
            }
          }, [_vm._v("生成推流地址")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.handleCreatePreNotice(scope.row)
              }
            }
          }, [_vm._v("直播预告")]), _vm._v(" "), _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.handleUploadVideo(scope.row)
              }
            }
          }, [_vm._v("视频上传")])], 1), _vm._v(" "), _c('el-button', {
            attrs: {
              "slot": "reference",
              "type": "text"
            },
            slot: "reference"
          }, [_c('i', {
            staticClass: "iconfont icon-angle-double-right"
          })])], 1)]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "anchor_id",
        "label": "主播ID",
        "width": "90"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "user_id",
        "label": "会员ID",
        "width": "90"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "inca_id",
        "label": "店铺名称",
        "width": "90",
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.distributor.name))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "员工姓名",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.name))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "nickname",
        "label": "员工昵称",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.nickname))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "mobile",
        "label": "手机号",
        "width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.mobile))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "is_auth",
        "align": "center",
        "label": "是否授权",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            attrs: {
              "active-value": "1",
              "inactive-value": "0",
              "active-color": "#13ce66",
              "inactive-color": "#ff4949"
            },
            on: {
              "change": function($event) {
                return _vm.switchAuth(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.is_auth),
              callback: function($$v) {
                _vm.$set(scope.row, "is_auth", $$v)
              },
              expression: "scope.row.is_auth"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "is_record",
        "align": "center",
        "label": "是否录播",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            attrs: {
              "active-value": "1",
              "inactive-value": "0",
              "active-color": "#13ce66",
              "inactive-color": "#ff4949"
            },
            on: {
              "change": function($event) {
                return _vm.switchRecord(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.is_record),
              callback: function($$v) {
                _vm.$set(scope.row, "is_record", $$v)
              },
              expression: "scope.row.is_record"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "disabled",
        "label": "是否禁用",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.disabled == '0') ? _c('el-tag', {
            attrs: {
              "size": "mini",
              "effect": "plain",
              "type": "success"
            }
          }, [_vm._v("可用")]) : _c('el-tag', {
            attrs: {
              "size": "mini",
              "effect": "plain"
            }
          }, [_vm._v("禁用")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "status",
        "label": "主播状态",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.status == 'online') ? _c('el-tag', {
            attrs: {
              "size": "mini",
              "effect": "plain",
              "type": "success"
            }
          }, [_vm._v("在线")]) : _c('el-tag', {
            attrs: {
              "size": "mini",
              "effect": "plain",
              "type": "warning"
            }
          }, [_vm._v("离线")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "stream_name",
        "label": "直播流名称",
        "width": "90",
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.stream_name))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "updated_at",
        "label": "更新时间",
        "width": "160",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.updated_at, 'yyyy-MM-dd hh:mm:ss')))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "created_at",
        "label": "创建时间",
        "width": "160",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.created_at, 'yyyy-MM-dd hh:mm:ss')))]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50],
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4e7e7748", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e7e7748"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/live/anchor/list.vue
// module id = 2699
// module chunks = 0